module.exports = __webpack_public_path__ + "logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1642
// module chunks = 0